module.exports = __webpack_public_path__ + "static/FlutterUserPreferences-f9ac7b6222a757eb3972f5bf77e8ddad.jpg";